import { render, staticRenderFns } from "./AlarmCard.vue?vue&type=template&id=351a0a7a&scoped=true"
import script from "./AlarmCard.vue?vue&type=script&lang=js"
export * from "./AlarmCard.vue?vue&type=script&lang=js"
import style0 from "./AlarmCard.vue?vue&type=style&index=0&id=351a0a7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351a0a7a",
  null
  
)

export default component.exports